import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';

// Synced with vertical live IA (dropdown parents) 28/10/2026 DW
export const navItems: NavItem[] = [
  // Profile browse above Access Control 28/10/2026 DW
  {
    displayName: 'Profile',
    iconName: 'user-circle',
    route: '/profile',
  },
  {
    displayName: 'Access Control',
    iconName: 'lock-access',
    children: [
      {
        displayName: 'Users',
        iconName: 'point',
        route: '/access/users',
      },
    ],
  },
  {
    displayName: 'Product',
    iconName: 'package',
    children: [
      {
        displayName: 'Product List',
        iconName: 'point',
        route: '/pli/plitable',
      },
      {
        displayName: 'Product Link',
        iconName: 'point',
        route: '/mad/plntable',
      },
    ],
  },
  {
    displayName: 'Auth0',
    iconName: 'key',
    children: [
      {
        displayName: 'Application',
        iconName: 'point',
        route: '/auth0/application',
      },
      {
        displayName: 'Resource',
        iconName: 'point',
        route: '/auth0/resource',
      },
    ],
  },
  {
    displayName: 'Auth0 Permissions',
    iconName: 'shield-lock',
    children: [
      {
        displayName: 'Groups',
        iconName: 'point',
        route: '/auth0/groups',
      },
    ],
  },
  {
    displayName: 'Merchant Admin',
    iconName: 'building-store',
    children: [
      {
        displayName: 'Create Merchant Setup',
        iconName: 'point',
        route: '/mad/createmse',
      },
      {
        displayName: 'Merchant Setup',
        iconName: 'point',
        route: '/mad/msetable',
      },
      {
        displayName: 'Service Point Setup',
        iconName: 'point',
        route: '/mad/spstable',
      },
      {
        displayName: 'Merchant Financial Setup',
        iconName: 'point',
        route: '/mad/mfstable',
      },
    ],
  },
  {
    // POS-style device icon 28/10/2026 DW
    displayName: 'Device',
    iconName: 'device-tablet-dollar',
    children: [
      {
        displayName: 'Remote Device',
        iconName: 'point',
        route: '/device/remotedevicetable',
      },
    ],
  },
  {
    displayName: 'Portal',
    iconName: 'world',
    children: [
      {
        displayName: 'Portal Register',
        iconName: 'point',
        route: '/portal/portalregistertable',
      },
    ],
  },
  {
    displayName: 'SMS/EMAIL FUNCTIONS',
    iconName: 'mail',
    children: [
      {
        displayName: 'Token',
        iconName: 'point',
        route: '/sms/tokentable',
      },
      {
        displayName: 'Template',
        iconName: 'point',
        route: '/sms/templatetable',
      },
      {
        displayName: 'Event Link',
        iconName: 'point',
        route: '/sms/eventlinktable',
      },
    ],
  },
  {
    displayName: 'Notice Board',
    iconName: 'clipboard-list',
    children: [
      {
        displayName: 'Notice Board',
        iconName: 'point',
        route: '/noticeboard/noticeboard',
      },
      {
        displayName: 'Notice Board Template',
        iconName: 'point',
        route: '/noticeboard/noticeboardtemplate',
      },
      {
        displayName: 'Notice Board Bank',
        iconName: 'point',
        route: '/noticeboard/noticeboardbanktable',
      },
    ],
  },
  {
    displayName: 'Settings',
    iconName: 'settings',
    children: [
      {
        displayName: 'Global Update',
        iconName: 'point',
        route: '/settings/globalupdate',
      },
    ],
  },
];
